export default "__VITE_ASSET__6a433cfc__"